import type { TransactionInput } from './hooks';

const isNil = (value: unknown): value is null | undefined =>
  value === null || value === undefined;

// Not a conclusive check, but the aim is to narrow down the type
export const isTransaction = (value: unknown): value is TransactionInput => {
  return (
    typeof value === 'object' &&
    value !== null &&
    'symbol' in value &&
    'exchangeCode' in value &&
    'date' in value &&
    'units' in value &&
    'value' in value &&
    'totalValue' in value &&
    'type' in value &&
    !isNil(value.symbol) &&
    !isNil(value.exchangeCode) &&
    !isNil(value.date) &&
    !isNil(value.units) &&
    !isNil(value.value) &&
    !isNil(value.totalValue) &&
    !isNil(value.type)
  );
};
